const onlineProposalFields = ['proposal_template', 'contract_by_project', 'contract_by_system', 'testimonials']

export default onlineProposalFields
